import Referral from 'views/TradingCompetitionV3/Referral'

const Page = () => <Referral />
// Open to every wallet chain: the pages stay readable anywhere, and each wallet action asks to switch to BNB Smart Chain.
Page.chains = []

export default Page
